import { render, staticRenderFns } from "./ImageAigcView.vue?vue&type=template&id=613eed7d&scoped=true&"
import script from "./ImageAigcView.vue?vue&type=script&lang=js&"
export * from "./ImageAigcView.vue?vue&type=script&lang=js&"
import style0 from "./ImageAigcView.vue?vue&type=style&index=0&id=613eed7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613eed7d",
  null
  
)

export default component.exports